const pound = String.fromCharCode(163)

export const formatPrice = (amount?: string | number): string => {
  if (!amount) {
    return `${pound}0.00`
  }

  return `${pound}${typeof amount === 'string' ? parseFloat(amount).toFixed(2) : amount.toFixed(2)}`
}

export const formatLabelPlural = (string: string, numItem: number): string => {
  if (numItem > 1) {
    return `${string}s (${numItem})`
  } else if (numItem === 1) {
    return `${string} (${numItem})`
  }

  return string
}

export const formatRecipeDiscount = (recipeDiscountPercent?: number): string => {
  if (recipeDiscountPercent) {
    return `${Math.ceil(recipeDiscountPercent)}% discount`
  }

  return 'Discount'
}

export const formatSurcharge = (value: number): string => {
  const formattedValue = Math.abs(value).toFixed(2)

  if (value === 0) return `£${formattedValue}`

  return value < 0 ? `-£${formattedValue}` : `+£${formattedValue}`
}
